import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { Fade, Slide } from '@material-ui/core';
import { StyleSheet, css } from 'aphrodite';

import { AppStyles } from '../styles/AppTheme';
import { AppHelper } from '../helpers/AppHelper';
import { Helper } from '../common/helpers/Helper';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { TableComponent } from '../common/components/TableComponent';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export class CampaignHistoryDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchState: null,
      errMsg: '',
      items: [],
    };
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Time: (current) => AppHelper.formatTimestamp(current.ts),
      'Who (userId)': (current) => current.userEmail,
      Action: (current) => <div className={css(Styles.commentStyle)}>{current.comment}</div>
    };
  }

  componentDidMount() {
    if (this.props.isOpen && this.props.current && this.props.current.id) {
      this.fetchCampaignHistory();
    }
  }

  componentDidUpdate(prevProps) {
    const isOpenedNow = this.props.isOpen && !prevProps.isOpen;
    const campaignChanged = (
      this.props.current &&
      prevProps.current &&
      this.props.current.id !== prevProps.current.id
    );

    if ((isOpenedNow || campaignChanged) && this.props.current && this.props.current.id) {
      this.fetchCampaignHistory();
    }
  }

  fetchCampaignHistory() {
    this.setState({
      fetchState: ApiHelper.State.LOADING,
      errMsg: '',
      items: [],
    });

    ApiHelper.call({
      method: 'GET',
      paths: ['miscs', 'campaignhistory'],
      queryParams: { campaignId: this.props.current.id }
    }, (err, result) => {
      if (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getErrorMsg(err),
        });
        return;
      }

      this.setState({
        fetchState: ApiHelper.State.READY,
        items: result && result.items ? result.items : [],
      });
    });
  }

  onCloseModal = () => {
    this.props.onClosed();
  }

  renderContent() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return <div className={css(Styles.stateContainer)}>{UiHelper.componentLoadingView()}</div>;
    }

    if (this.state.fetchState === ApiHelper.State.ERROR) {
      return <div className={css(Styles.stateContainer)}>{UiHelper.componentErrorView(this)}</div>;
    }

    if (!this.state.items.length) {
      return <div className={css(Styles.stateContainer)}>{UiHelper.emptyView()}</div>;
    }

    return (
      <div className={css(Styles.tableContainer)}>
        <TableComponent
          compact
          tableHeadersMap={this.tableHeadersMap}
          items={this.state.items}
          noTableHead={false}
          onActions={() => []}
          bodyCellStyle={Styles.historyBodyCell}
        />
      </div>
    );
  }

  render() {
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.props.title}
        fullWidth={true}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.props.title}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal}>
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          {this.renderContent()}
        </div>
      </Dialog>
    );
  }
}

const Styles = StyleSheet.create({
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: 'black',
    fontSize: 26,
    fontWeight: 600
  },
  modalContent: {
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
    minHeight: 260,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    width: '100%',
    minWidth: 900,
    borderRadius: 40,
    '@media (max-width: 1024px)': {
      minWidth: 'unset',
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  tableContainer: {
    maxHeight: '60vh',
    overflowY: 'auto',
  },
  stateContainer: {
    minHeight: 220,
  },
  commentStyle: {
    maxWidth: 400,
    whiteSpace: 'pre-line'
  },
  historyBodyCell: {
    backgroundColor: '#F1F3F5',
    borderColor: '#F1F3F5',
  }
});



// WEBPACK FOOTER //
// ./src/components/CampaignHistoryDialog.js